import { NEWS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminEditorChoiceService = {
  getAll: (params: any) => requests.get(`${NEWS_URL}/editor-choice`, params),
  update: (id: number) => requests.put(`${NEWS_URL}/editor-choice/${id}`),
  updatePosition: (params: any) =>
    requests.patch(`${NEWS_URL}/editor-choice`, params),
};
